/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GroupOrderJoinPreviewQueryVariables = Types.Exact<{
  joinCode: Types.Scalars['String']['input'];
}>;

export type GroupOrderJoinPreviewQuery = {
  readonly __typename?: 'Query';
  readonly multipartyOrderPreview:
    | { readonly __typename: 'MultipartyOrderNotFound'; readonly errorMessage: string }
    | {
        readonly __typename: 'MultipartyOrderPreviewSuccess';
        readonly hostDisplayName: string;
        readonly orderDisplayName: string;
        readonly deliveryAddressSummary: string | null;
        readonly restaurant: {
          readonly __typename: 'Restaurant';
          readonly id: string;
          readonly name: string;
          readonly isOutpost: boolean;
          readonly address: string;
          readonly city: string;
          readonly state: string;
          readonly zipCode: string;
          readonly slug: string;
        };
      }
    | { readonly __typename: 'OrderLocked'; readonly errorMessage: string };
};

export type GroupOrderJoinMutationVariables = Types.Exact<{
  input: Types.JoinMultipartyOrderInput;
}>;

export type GroupOrderJoinMutation = {
  readonly __typename?: 'Mutation';
  readonly joinMultipartyOrder:
    | {
        readonly __typename: 'JoinMultipartyOrderSuccess';
        readonly order: {
          readonly __typename: 'Order';
          readonly id: string;
          readonly restaurant: {
            readonly __typename: 'Restaurant';
            readonly id: string;
            readonly slug: string;
          };
        };
      }
    | { readonly __typename: 'MultipartyOrderNotFound'; readonly errorMessage: string }
    | { readonly __typename: 'OrderLocked'; readonly errorMessage: string }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly fieldErrors: ReadonlyArray<{
          readonly __typename?: 'FieldValidationError';
          readonly field: string;
          readonly message: string;
        }>;
      };
};

export const GroupOrderJoinPreviewDocument = gql`
  query GroupOrderJoinPreview($joinCode: String!) {
    multipartyOrderPreview(joinCode: $joinCode) {
      __typename
      ... on MultipartyOrderPreviewSuccess {
        hostDisplayName
        orderDisplayName
        deliveryAddressSummary
        restaurant {
          __typename
          id
          name
          isOutpost
          address
          city
          state
          zipCode
          slug
        }
      }
      ... on MultipartyOrderNotFound {
        errorMessage
      }
      ... on OrderLocked {
        errorMessage
      }
    }
  }
`;

export function useGroupOrderJoinPreviewQuery(
  options: Omit<Urql.UseQueryArgs<GroupOrderJoinPreviewQueryVariables>, 'query'>,
) {
  return Urql.useQuery<GroupOrderJoinPreviewQuery, GroupOrderJoinPreviewQueryVariables>({
    query: GroupOrderJoinPreviewDocument,
    ...options,
  });
}
export const GroupOrderJoinDocument = gql`
  mutation GroupOrderJoin($input: JoinMultipartyOrderInput!) {
    joinMultipartyOrder(input: $input) {
      __typename
      ... on JoinMultipartyOrderSuccess {
        order {
          __typename
          id
          restaurant {
            __typename
            id
            slug
          }
        }
      }
      ... on MultipartyOrderNotFound {
        errorMessage
      }
      ... on OrderLocked {
        errorMessage
      }
      ... on ValidationError {
        message
        fieldErrors {
          field
          message
        }
      }
    }
  }
`;

export function useGroupOrderJoinMutation() {
  return Urql.useMutation<GroupOrderJoinMutation, GroupOrderJoinMutationVariables>(
    GroupOrderJoinDocument,
  );
}
